import * as React from 'react';
import { observer } from 'mobx-react';
import { inject } from '../utils';
import { withTheme } from 'styled-components';
import { computed } from 'mobx';
import { DataStore, AccessibilityStore } from '../stores';
import Image from './Image';
import { Theme } from '../models/Theme';

interface IconProps {
    theme?: Theme;
    dataStore?: DataStore;
    accessibilityStore?: AccessibilityStore;
    fileName: string;
    accessibilityContext?: string;
    disableAltText?: boolean;
    display?: Array<string>;
    hide?: boolean;
    onClick?: () => void;
}

@inject('dataStore')
@inject('accessibilityStore')
@observer
class Icon extends React.Component<IconProps> {
    constructor(props) {
        super(props);
    }

    // filename without extension
    @computed
    get iconFileName(): string {
        const { fileName: originalFileName = '' } = this.props;
        if (
            typeof originalFileName !== 'string' ||
            originalFileName.length === 0
        ) {
            return undefined;
        }
        let fileName = originalFileName;
        // check if extension exists. Handles cases with no extension and files with '.' at the start of the name.
        const ext = fileName.slice(
            Math.max(0, fileName.lastIndexOf('.')) || Infinity
        );
        // remove the extension to get clean filename for accessiblity alt text lookup
        if (ext) {
            fileName = fileName.replace(ext, '');
        }
        return fileName;
    }

    // extension without the dot (.)
    @computed
    get iconExtension(): string {
        const { fileName: originalFileName = '' } = this.props;
        if (
            typeof originalFileName !== 'string' ||
            originalFileName.length === 0
        ) {
            return undefined;
        }
        // check if extension exists. Handles cases with no extension and files with '.' at the start of the name.
        let ext = originalFileName.slice(
            (Math.max(0, originalFileName.lastIndexOf('.')) || Infinity) + 1
        );
        if (!ext) {
            ext = 'svg';
        }
        return ext;
    }

    @computed
    get iconSrc(): string {
        const { dataStore } = this.props;

        const fileName = `${this.iconFileName}.${this.iconExtension}`;
        const src = dataStore.assetStore.getAssetUrl(fileName);
        return src;
    }

    @computed
    get altText(): string {
        const {
            accessibilityStore,
            accessibilityContext,
            disableAltText,
        } = this.props;
        const { altText } = accessibilityStore;

        if (disableAltText) {
            return '';
        }
        return altText(this.iconFileName, accessibilityContext);
    }

    render() {
        const { hide } = this.props;
        const src = this.iconSrc;

        if (hide || !src) {
            return null;
        }
        return <Image src={this.iconSrc} alt={this.altText} {...this.props} />;
    }
}

export default withTheme(Icon) as any;



// WEBPACK FOOTER //
// ./src/Components/Icon.tsx